"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderQueryFilterFields = exports.vehicleQueryFilterFields = void 0;
exports.vehicleQueryFilterFields = `
  filterGroups {
    id
    title
    filters {
      checked
      id
      label
      name
    }
  }
  make
  makeOptions {
    label
    value
  }
  modelSeries
  modelSeriesOptions {
    label
    value
  }
  model
  modelOptions {
    label
    value
  }
  searchQuery
`;
exports.orderQueryFilterFields = `
  dealerIds
  salesPersonIdent
  searchQuery
  stati
  status
`;
//# sourceMappingURL=filter.js.map